import { useEffect, useState } from 'react';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { screenSize } from 'lib/utils';
import Arrow from './careers_arrow';

/**
 * @param {Object} props
 * @param {Array<Object>} items - a list of carousel items with an image url
 * @returns slider populated with given images
 */
const CareersCarousel = ({ items }) => {
  const [isMobile, setIsMobile] = useState(screenSize() < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(screenSize() < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Splide
      hasTrack={false}
      options={{
        type: 'loop',
        gap: isMobile ? '1rem' : '1.625rem',
        fixedWidth: isMobile ? '225px' : '380px',
        pagination: false,
        drag: 'free',
        arrows: true,
        rewind: false,
      }}>
      <SplideTrack>
        {items.map(item => (
          <SplideSlide key={item.src}>
            <picture>
              <source srcSet={item.srcAvif} />
              <source srcSet={item.srcWebp} />
              <img src={item.src} alt="" />
            </picture>
          </SplideSlide>
        ))}
      </SplideTrack>
      <div className="splide__arrows height-100">
        <button
          type="button"
          className="splide__arrow fl ai-c height-100 bg-transparent width-auto np m-pl-10 splide__arrow--prev"
          aria-label="next slides">
          <div className="splide__arrow-custom fl ai-c jc-c">
            <Arrow
              color="#666666"
              size={isMobile ? '16' : '18'}
              direction="e"
            />
          </div>
        </button>
        <button
          type="button"
          className="splide__arrow fl ai-c height-100 bg-transparent width-auto np m-pl-10 splide__arrow--next"
          aria-label="previous slides">
          <div className="splide__arrow-custom fl ai-c jc-c">
            <Arrow
              color="#666666"
              size={isMobile ? '16' : '18'}
              direction="e"
            />
          </div>
        </button>
      </div>
    </Splide>
  );
};
export default CareersCarousel;
